export default "__VITE_ASSET__33baa2a4__"